import { Editor, Element } from 'slate';
import { inlineLinkType } from '../plugins/inlineLink/inlineLinkType';
import { AulaEditorInstance } from '../types';

export const hasLink = (editor: AulaEditorInstance, at = editor.selection) => {
  if (!at) return false;
  const [link] = Editor.nodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) && Element.isElement(n) && n.type === inlineLinkType,
    at,
  });
  return !!link;
};
